const SkeletonAvatar = ({ active, loading, className }) => {
  const classNameSkeleton =
    'skeleton-avatar' +
    (className ? ` ${className}` : '') +
    (loading === true ? ' skeleton-avatar--loading' : '') +
    (active === true && loading === true ? ' skeleton-avatar--active' : '')

  return <div className={classNameSkeleton} />
}

export default SkeletonAvatar
